/**
 * Retrieve the textCardElements for an accountCard
 *
 * @param {Object} options The options.
 * @param {Object} options.accountCard the accountCard
 * @param {Boolean} options.emptyOnly whether to return only text elements whose content is empty
 * @returns {Array}
 */
import { CARD_ELEMENT_TYPE } from '../../../../../../../../../../../../services/cards/constants';

export const getTextCardElements = ({ accountCard, emptyOnly = false }) => {
  if (!accountCard) {
    return [];
  }

  const accountCardSide = accountCard.account_card_sides?.[0];

  const textCardElements = accountCardSide.card_side.card_template.card_elements.filter(
    element => element.type === CARD_ELEMENT_TYPE.TEXT,
  );

  if (emptyOnly) {
    return textCardElements.filter(element => {
      const cardSideConfig = accountCardSide.card_side.card_element_configurations.find(
        config => config.card_element.id === element.id,
      );
      const elementConfig = accountCardSide.card_element_configurations.find(
        config => config.card_element.id === element.id,
      );

      return cardSideConfig.is_editable && !elementConfig?.text;
    });
  }

  return textCardElements;
};
/**
 * Determines whether PrintProductsEmptyTextAlert should fire based on the state
 * of empty TEXT cardElementConfigurations.
 *
 * @param {Object} options The options.
 * @param {Object} options.accountCard The current accountCard
 * @returns {boolean}
 */
export const shouldAlertEmptyText = ({ accountCard }) => {
  return getTextCardElements({ accountCard, emptyOnly: true }).length > 0;
};
